/*
 * Gift wrapping toggle + free delivery progress bar.
 * The gift wrapping product is added/removed by the basket checkbox only. It is
 * kept at quantity 1 and removed automatically if it's the only thing left.
 */
(function () {
  var config = window.cartPerks || {};
  var giftWrapProductId = Number(config.giftWrapProductId) || 0;
  var isCartPage = config.template === 'cart';
  var fixPending = false;
  var lastPercentWidth = null;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart request failed: ' + res.status);
      return res.json();
    });
  }

  // Returns the /cart/change.js body needed to tidy up the gift wrapping line, or null
  function giftWrapFix(cart) {
    if (!giftWrapProductId || !cart || !cart.items) return null;
    var wrapLines = cart.items.filter(function (item) {
      return item.product_id === giftWrapProductId;
    });
    if (!wrapLines.length) return null;
    if (wrapLines.length === cart.items.length) return { id: wrapLines[0].key, quantity: 0 };
    if (wrapLines[0].quantity > 1) return { id: wrapLines[0].key, quantity: 1 };
    return null;
  }

  function applyFix(fix) {
    if (!fix || fixPending) return;
    fixPending = true;
    var ajaxCart = window.liquidAjaxCart;
    if (!isCartPage && ajaxCart) {
      ajaxCart.change(fix);
      return;
    }
    postJSON('/cart/change.js', fix)
      .then(function () {
        if (isCartPage) window.location.reload();
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  // Re-enable toggles that a failed request left disabled
  function resetToggles(cart) {
    var hasWrap = !!(cart && cart.items && cart.items.some(function (item) {
      return item.product_id === giftWrapProductId;
    }));
    document.querySelectorAll('[data-gift-wrap].is-busy').forEach(function (wrap) {
      wrap.classList.remove('is-busy');
      var box = wrap.querySelector('[data-gift-wrap-toggle]');
      box.disabled = false;
      box.checked = hasWrap;
    });
  }

  function formatMoney(minorUnits, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency
      }).format(minorUnits / 100);
    } catch (error) {
      return (minorUnits / 100).toFixed(2) + ' ' + currency;
    }
  }

  // Liquid can only compare against the threshold in the shop currency. For customers shown
  // another currency, convert it at the same rate Shopify uses for the discount minimums.
  function localiseThresholds() {
    var activeCurrency = window.Shopify && window.Shopify.currency;
    var rate = activeCurrency ? parseFloat(activeCurrency.rate) : NaN;

    document.querySelectorAll('[data-cart-progress], [data-gift-wrap]').forEach(function (el) {
      if (el.dataset.currency === config.shopCurrency) return;
      if (!rate) return;

      var threshold = Math.round(Number(el.dataset.threshold) * rate);
      var total = Number(el.dataset.total);
      var remaining = Math.max(threshold - total, 0);

      if (el.hasAttribute('data-gift-wrap')) {
        // Already in the cart: Liquid shows the real line price
        if (!el.querySelector('[data-gift-wrap-paid]')) return;
        el.querySelector('[data-gift-wrap-paid]').hidden = remaining === 0;
        el.querySelector('[data-gift-wrap-free]').hidden = remaining > 0;
        return;
      }

      var percent = threshold > 0 ? Math.min(Math.floor((total * 100) / threshold), 100) : 100;
      var message = el.querySelector('[data-cart-progress-message]');
      message.textContent = '';
      if (remaining === 0) {
        message.textContent = config.progressSuccess;
      } else {
        var parts = String(config.progressMessage).split('[amount]');
        var amount = document.createElement('strong');
        amount.textContent = formatMoney(remaining, el.dataset.currency);
        message.append(parts[0]);
        if (parts.length > 1) message.append(amount, parts.slice(1).join(''));
      }
      el.classList.toggle('is-complete', remaining === 0);
      el.querySelector('.cart-progress__track').setAttribute('aria-valuenow', percent);
      el.querySelector('[data-cart-progress-fill]').style.width = percent + '%';
      el.hidden = false;
    });
  }

  // The drawer is re-rendered on every change, so slide the bar from its previous width
  function animateProgress() {
    var fill = document.querySelector('#shopify-section-my-ajax-cart [data-cart-progress-fill]');
    if (!fill) {
      lastPercentWidth = null;
      return;
    }
    var target = fill.style.width;
    if (lastPercentWidth !== null && lastPercentWidth !== target) {
      fill.style.transition = 'none';
      fill.style.width = lastPercentWidth;
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.width = target;
    }
    lastPercentWidth = target;
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest('[data-gift-wrap-toggle]');
    if (!box) return;

    var variantId = Number(box.dataset.variantId);
    var ajaxCart = window.liquidAjaxCart;
    box.disabled = true;
    box.closest('[data-gift-wrap]').classList.add('is-busy');

    // In the drawer, let Liquid Ajax Cart re-render it. On the cart page, reload.
    if (!isCartPage && ajaxCart && box.closest('#shopify-section-my-ajax-cart')) {
      if (box.checked) {
        ajaxCart.add({ items: [{ id: variantId, quantity: 1 }] });
      } else {
        ajaxCart.change({ id: String(variantId), quantity: 0 });
      }
      return;
    }

    var request = box.checked
      ? postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      : postJSON('/cart/change.js', { id: String(variantId), quantity: 0 });
    request
      .catch(function (error) {
        console.error(error);
      })
      .then(function () {
        window.location.reload();
      });
  });

  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    var ajaxCart = window.liquidAjaxCart;
    var cart = ajaxCart && ajaxCart.cart;
    requestAnimationFrame(function () {
      resetToggles(cart);
      localiseThresholds();
      animateProgress();
    });

    var fix = giftWrapFix(cart);
    if (!fix) {
      fixPending = false;
      return;
    }
    applyFix(fix);
  });

  document.addEventListener('DOMContentLoaded', function () {
    localiseThresholds();
    animateProgress();
    if (!config.checkGiftWrap) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var fix = giftWrapFix(cart);
        if (!fix) return;
        fixPending = true;
        return postJSON('/cart/change.js', fix).then(function () {
          if (isCartPage) {
            window.location.reload();
          } else if (window.liquidAjaxCart) {
            window.liquidAjaxCart.update({}, {});
          }
        });
      })
      .catch(function (error) {
        console.error(error);
      });
  });
})();
